"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var testEnv = function () { return ({
    NAME: 'test',
    ASSET_ROOT: '/assets/',
    BOOKSTORE_ROUTER_BASE_NAME: '/bookstore',
    BUILDER_HOST: 'http://rowan.local:3001/',
    BUILDER_UI_HOST: 'http://rowan.local:9000/',
    PLATFORM: 'web',
    NATIVE_APPLICATION: false,
    READER_BASE_URL: 'https://s3.amazonaws.com/rowan-builder-stag/reader-v-2',
    READER_URL: 'http://rowan.local:9000/reader.html',
    RUCKSACK_CALLBACK: 'http://rowan.local:9000/reader.html',
    RUCKSACK_CLIENT_ID: '8fcad489a7c92a2ece47260a9b1ec3946553c8cd8b814a184b7f7b0dfcb240da',
    RUCKSACK_HOST: 'http://rowan.local:3000',
    RUCKSACK_URL: 'http://rowan.local:3000/',
    RUCKSACK_SECRET: '3e961fa7f441bd5b703a1350cab3ef169e7d29893e962521f84f387b8b30002b',
    BOOKSHELF_URL: 'http://rowan.local:9000/bookstore',
    BOOKSHELF_AUTH_URL: 'http://rowan.local:9000/loadAuthToken.html',
    FEATURE_FLAG_URL: 'http://rowan.local:9000/feature-flags.json',
    API_GATEWAY_URL: 'http://rowan.local:5000/',
    SECURE_COOKIES: true,
    COOKIE_DOMAIN: 'rowan.nyc'
}); };
exports.default = testEnv;
